import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useUserId } from "../query/hooks/helpers";
import { useQueryUserProfile } from "../query/users/queries";
import { WSQueries } from "../query/WSQuery";
import { AdminSignInAsMember } from "./screens/AdminSignInAsMember";

const ADMIN_EMAIL_DOMAINS = ["@wingspan.app", "@m.wingspan.app"];

export const Admin: React.FC = () => {
  const userId = useUserId();
  const userQuery = useQueryUserProfile(userId);

  return (
    <WSQueries queries={{ userQuery }}>
      {({ userQuery: { data: user } }) => (
        <Switch>
          {ADMIN_EMAIL_DOMAINS.some(domain => user.email.endsWith(domain)) ? (
            <Route
              path="/member/admin/sign-in-as-member"
              component={AdminSignInAsMember}
            />
          ) : null}

          <Redirect from="*" to="/member/dashboard" />
        </Switch>
      )}
    </WSQueries>
  );
};
